import React, { Component } from 'react';

import SearchBar from '../components/SearchBar';
import '../styles/MainPage.css';

// import { Redirect } from 'react-router';

class MainPage extends Component {

    render() {
        return (
            <div className="main-page">
                <div className="main-page-search-box">
                    <SearchBar />
                </div>
            </div>
        );
    }

    componentDidMount() {
        document.title = 'Course Search';
    }
}

export default MainPage;


// WEBPACK FOOTER //
// ./src/containers/MainPage.js